import { ReactNode } from 'react';
import Accordion from '@/components/data-display/accordion';
import ReactHtmlParser, { convertNodeToElement } from 'react-html-parser';
import { markdownToHTML } from '../markdown-to-html';
import { NodeType } from './transform-markdown-to-react-html.types';

function formatHtml(html: string) {
  let formattedHtml = html;

  formattedHtml = formattedHtml.replace(
    /<p>{collapse}<\/p>|{collapse}/g,
    `<Accordion>`,
  );
  formattedHtml = formattedHtml.replace(
    /<p>{\/collapse}<\/p>|{\/collapse}<\/p>|{\/collapse}/g,
    '</Accordion>',
  );

  formattedHtml = formattedHtml.replace(
    /<table>/g,
    '<table class="legal-table" />',
  );

  formattedHtml = formattedHtml.replace(
    /{chevron}/g,
    '<span class="chevron-right" />',
  );

  return formattedHtml;
}

function transform(node: NodeType) {
  if (node.name === 'accordion') {
    const foundAccordionTitle = node?.children.find(
      (item: { name: string }) => item.name === 'h2' || item.name === 'h3',
    );

    if (foundAccordionTitle) {
      const accordionContent = node.children.filter(
        item => item !== foundAccordionTitle,
      );
      const title = foundAccordionTitle?.children[0]?.data ?? '';
      const renderChildren = (): ReactNode => {
        return accordionContent.map((child, childIndex: number) => {
          return (
            // eslint-disable-next-line react/no-array-index-key
            <div key={childIndex}>
              {convertNodeToElement(child, childIndex, transform)}
            </div>
          );
        });
      };

      return (
        <Accordion title={title} isOpen={false}>
          {renderChildren()}
        </Accordion>
      );
    }
  }
  return convertNodeToElement(node, Math.random(), transform);
}

const transformMarkdownToReactHtml = (content: string) => {
  const html = markdownToHTML(content);
  const formattedHtml = formatHtml(html);

  return ReactHtmlParser(formattedHtml, { transform });
};

export default transformMarkdownToReactHtml;
